'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var words = require('./words.js');
function kebabCase(str) {
    var words$1 = words.words(str);
    return words$1.map(function(word) {
        return word.toLowerCase();
    }).join('-');
}
exports.kebabCase = kebabCase;
